export default {
    data() {
        return {

            provinceAndCity: [{
                    id: 1,
                    label: "آذربايجان شرقي",
                    cities: [
                        "تبريز",

                        "مراغه",

                        "ميانه",

                        "شبستر",

                        "مرند",

                        "جلفا",

                        "سراب",

                        "هاديشهر",

                        "بناب",

                        "تسوج",

                        "اهر",

                        "هريس",

                        "هشترود",

                        "ملكان",

                        "بستان آباد",

                        "ورزقان",

                        "اسكو",

                        "ممقان",

                        "صوفیان",

                        "ایلخچی",

                        "خسروشهر",

                        "باسمنج",
                        "سهند",

                    ]
                },
                {
                    id: 2,
                    label: "آذربايجان غربي",
                    cities: [
                        "اروميه",

                        "نقده",

                        "ماكو",

                        "تكاب",

                        "خوي",

                        "مهاباد",

                        "سر دشت",

                        "چالدران",

                        "بوكان",

                        "مياندوآب",

                        "سلماس",

                        "شاهين دژ",

                        "پيرانشهر",

                        "اشنويه",
                        "پلدشت",

                    ]
                },
                {
                    id: 3,
                    label: "اردبيل",
                    cities: [
                        "اردبيل",

                        "پارس آباد",

                        "خلخال",

                        "مشگين شهر",

                        "نمين",

                        "نير",
                        "گرمي",

                    ]
                },
                {
                    id: 4,
                    label: "اصفهان",
                    cities: [
                        "اصفهان",

                        "فلاورجان",

                        "گلپايگان",

                        "دهاقان",

                        "نطنز",

                        "تيران",

                        "كاشان",

                        "اردستان",

                        "سميرم",

                        "درچه",

                        "کوهپایه",

                        "مباركه",

                        "شهرضا",

                        "خميني شهر",

                        "نجف آباد",

                        "زرين شهر",

                        "آران و بيدگل",

                        "باغ بهادران",

                        "خوانسار",

                        "علويجه",

                        "عسگران",

                        "حاجي آباد",

                        "تودشک",
                        "ورزنه",
                    ]
                },
                {
                    id: 5,
                    label: "ايلام",
                    cities: [

                        "ايلام",

                        "مهران",

                        "دهلران",

                        "آبدانان",

                        "دره شهر",

                        "ايوان",

                        "سرابله",

                    ]
                },
                {
                    id: 6,
                    label: "بوشهر",
                    cities: [

                        "بوشهر",

                        "دير",

                        "كنگان",

                        "گناوه",

                        "خورموج",

                        "اهرم",

                        "برازجان",

                        "جم",

                        "کاکی",

                        "عسلویه",

                    ]
                },
                {
                    id: 7,
                    label: "تهران",
                    cities: [

                        "تهران",

                        "ورامين",

                        "فيروزكوه",

                        "ري",

                        "دماوند",

                        "اسلامشهر",

                        "رودهن",

                        "لواسان",

                        "بومهن",

                        "تجريش",

                        "فشم",

                        "كهريزك",

                        "پاكدشت",

                        "چهاردانگه",

                        "شريف آباد",

                        "قرچك",

                        "باقرشهر",

                        "شهريار",

                        "رباط كريم",

                        "قدس",

                        "ملارد",

                    ]
                },
                {
                    id: 8,
                    label: "چهارمحال بختياري",
                    cities: [

                        "شهركرد",

                        "فارسان",

                        "بروجن",

                        "چلگرد",

                        "اردل",

                        "لردگان",

                    ]
                },
                {
                    id: 9,
                    label: "خراسان جنوبي",
                    cities: [

                        "قائن",

                        "فردوس",

                        "بيرجند",

                        "نهبندان",

                        "سربيشه",

                    ]
                },
                {
                    id: 10,
                    label: "خراسان رضوي",
                    cities: [

                        "مشهد",

                        "نيشابور",

                        "سبزوار",

                        "كاشمر",

                        "گناباد",

                        "طبس",

                        "تربت حيدريه",

                        "خواف",

                        "تربت جام",

                        "تايباد",

                        "قوچان",

                        "سرخس",

                        "فريمان",

                        "چناران",

                        "درگز",

                        "طرقبه",

                    ]
                },
                {
                    id: 11,
                    label: "خراسان شمالي",
                    cities: [

                        "بجنورد",

                        "اسفراين",

                        "جاجرم",

                        "شيروان",

                        "آشخانه",

                    ]
                },
                {
                    id: 12,
                    label: "خوزستان",
                    cities: [

                        "اهواز",

                        "ايرانشهر",

                        "شوش",

                        "آبادان",

                        "خرمشهر",

                        "مسجد سليمان",

                        "ايذه",

                        "شوشتر",

                        "انديمشك",

                        "سوسنگرد",

                        "هويزه",

                        "دزفول",

                        "شادگان",

                        "بندر ماهشهر",

                        "بندر امام خميني",

                        "بهبهان",

                        "رامهرمز",

                        "باغ ملك",

                        "هنديجان",

                        "لالي",

                        "رامشیر",

                        "حمیدیه",

                        "ملاثانی",

                        "شادگان",

                    ]
                },
                {
                    id: 13,
                    label: "زنجان",
                    cities: [

                        "زنجان",

                        "ابهر",

                        "خدابنده",

                        "ماهنشان",

                        "خرمدره",

                        "آب بر",

                        "قيدار",

                    ]
                },
                {
                    id: 14,
                    label: "سمنان",
                    cities: [

                        "سمنان",

                        "شاهرود",

                        "گرمسار",

                        "ايوانكي",

                        "دامغان",

                        "بسطام",

                    ]
                },
                {
                    id: 15,
                    label: "سيستان و بلوچستان",
                    cities: [

                        "زاهدان",

                        "چابهار",

                        "خاش",

                        "سراوان",

                        "زابل",

                        "سرباز",

                        "ايرانشهر",

                        "ميرجاوه",

                    ]
                },
                {
                    id: 16,
                    label: "فارس",
                    cities: [

                        "شيراز",

                        "اقليد",

                        "داراب",

                        "فسا",

                        "مرودشت",

                        "آباده",

                        "كازرون",

                        "سپيدان",

                        "لار",

                        "فيروز آباد",

                        "جهرم",

                        "استهبان",

                        "لامرد",

                        "مهر",

                        "حاجي آباد",

                        "اردكان",

                        "صفاشهر",

                        "ارسنجان",

                        "سوريان",

                        "فراشبند",

                        "سروستان",

                        "زرقان",

                        "کوار",

                        "بوانات",

                        "خرامه",

                        "خنج",

                    ]
                },
                {
                    id: 17,
                    label: "قزوين",
                    cities: [

                        "قزوين",

                        "تاكستان",

                        "آبيك",

                        "بوئين زهرا",

                    ]
                },
                {
                    id: 18,
                    label: "قم",
                    cities: [

                        "قم",

                    ]
                },
                {
                    id: 19,
                    label: "کرج",
                    cities: [

                        "طالقان",

                        "نظرآباد",

                        "اشتهارد",

                        "هشتگرد",

                        "كرج",

                        "ماهدشت",

                    ]
                },
                {
                    id: 20,
                    label: "كردستان",
                    cities: [

                        "سنندج",

                        "بانه",

                        "بيجار",

                        "سقز",

                        "قروه",

                        "مريوان",

                        "صلوات آباد",

                        "حسن آباد",

                    ]
                },
                {
                    id: 21,
                    label: "كرمان",
                    cities: [

                        "كرمان",

                        "راور",

                        "انار",

                        "کوهبنان",

                        "رفسنجان",

                        "بافت",

                        "سيرجان",

                        "كهنوج",

                        "زرند",

                        "بم",

                        "جيرفت",

                        "بردسير",

                    ]
                },
                {
                    id: 22,
                    label: "كرمانشاه",
                    cities: [

                        "كرمانشاه",

                        "اسلام آباد غرب",

                        "كنگاور",

                        "سنقر",

                        "قصر شيرين",

                        "هرسين",

                        "صحنه",

                        "پاوه",

                        "جوانرود",

                    ]
                },
                {
                    id: 23,
                    label: "كهكيلويه و بويراحمد",
                    cities: [

                        "ياسوج",

                        "گچساران",

                        "دوگنبدان",

                        "سي سخت",

                        "دهدشت",

                    ]
                },
                {
                    id: 24,
                    label: "گلستان",
                    cities: [

                        "گرگان",

                        "آق قلا",

                        "گنبد كاووس",

                        "علي آباد كتول",

                        "كردكوی",

                        "كلاله",

                        "آزاد شهر",

                        "راميان",

                    ]
                },
                {
                    id: 25,
                    label: "گيلان",
                    cities: [

                        "رشت",

                        "منجيل",

                        "لنگرود",

                        "تالش",

                        "آستارا",

                        "ماسوله",

                        "رودبار",

                        "فومن",

                        "صومعه سرا",

                        "هشتپر",

                        "ماسال",

                        "شفت",

                        "املش",

                        "لاهیجان",

                    ]
                },
                {
                    id: 26,
                    label: "لرستان",
                    cities: [

                        "خرم آباد",

                        "ماهشهر",

                        "دزفول",

                        "بروجرد",

                        "دورود",

                        "اليگودرز",

                        "ازنا",

                        "نور آباد",

                        "كوهدشت",

                        "الشتر",

                    ]
                },
                {
                    id: 27,
                    label: "مازندران",
                    cities: [

                        "ساري",

                        "آمل",

                        "بابل",

                        "بابلسر",

                        "بهشهر",

                        "تنكابن",

                        "جويبار",

                        "چالوس",

                        "رامسر",

                        "قائم شهر",

                        "نكا",

                        "نور",

                        "بلده",

                        "نوشهر",

                        "محمود آباد",

                    ]
                },
                {
                    id: 28,
                    label: "مركزي",
                    cities: [

                        "اراك",

                        "آشتيان",

                        "تفرش",

                        "خمين",

                        "دليجان",

                        "ساوه",

                        "محلات",

                        "شازند",

                    ]
                },
                {
                    id: 29,
                    label: "هرمزگان",
                    cities: [

                        "بندرعباس",

                        "قشم",

                        "كيش",

                        "بندر لنگه",

                        "بستك",

                        "حاجي آباد",

                        "دهبارز",

                        "ميناب",

                        "بندر جاسك",

                        "بندر خمیر",

                        "قشم",

                    ]
                },
                {
                    id: 30,
                    label: "همدان",
                    cities: [

                        "همدان",

                        "ملاير",

                        "نهاوند",

                        "رزن",

                        "اسدآباد",

                        "بهار",

                    ]
                },
                {
                    id: 31,
                    label: "يزد",
                    cities: [

                        "يزد",

                        "تفت",

                        "اردكان",

                        "ابركوه",

                        "ميبد",

                        "طبس",

                        "بافق",

                        "مهريز",

                        "اشكذر",

                        "هرات",

                        "خضرآباد",

                        "زارچ",

                    ]
                }
            ],
            maritalStatus: [
                "متاهل",
                "مجرد"
            ],
            genderOption: [
                "مرد",
                "زن",
            ],
            religionOption: [
                "شیعه",
                "سنی",

            ],
            educations: [
                "دکتری",
                "کارشناسی ارشد",
                "کارشناسی",
                "دیپلم",
                "سیکل",

            ],
            yearInsurance: [
                12,
                11,
                10,
                9,
                8,
                7,
                6,
                5,
                4,
                3,
                2,
                1
            ],

            monthInsurance: [12,
                11,
                10,
                9,
                8,
                7,
                6,
                5,
                4,
                3,
                2,
                1,

            ]
        }
    },
}